<template>
  <div
    class="eyedropper"
    :style="boxStyle"
  >
    <canvas
      ref="canvasEl"
      @mousedown="mousedown($event)"
      @mousemove="mousemove($event)"
      @mouseleave="mouseleave($event)"
    ></canvas>
    <div
      v-show="isShowTip"
      class="eyedropper-tip"
      :style="tipStyle"
    ></div>
  </div>
</template>
<script>
export default {
  props: {
    msg: {
      type: Object,
      default: null,
      timeout: null
    }
  },
  data() {
    return {
      ctx: null,
      isShowTip: false,
      matrix: {
        x: 0,
        y: 0,
        w: 0,
        h: 0
      },
      tm: {
        x: 0,
        y: 0,
        bg: '#FFFFFF'
      }
    };
  },
  computed: {
    boxStyle() {
      const style = {};
      style.width = this.matrix.w + 'px';
      style.height = this.matrix.h + 'px';
      style.top = this.matrix.y + 'px';
      style.left = this.matrix.x + 'px';
      return style;
    },
    tipStyle() {
      const style = {};
      style.top = this.tm.y + 'px';
      style.left = this.tm.x + 'px';
      style.backgroundColor = this.tm.bg;

      return style;
    }
  },
  async mounted() {
    let dom = document.querySelector(this.msg.selector);
    if (!dom) {
      this.$emit('cancel');
      return;
    }

    ({ height: this.matrix.h, width: this.matrix.w, top: this.matrix.y, left: this.matrix.x } = dom.getBoundingClientRect());
    let cc = await this.cloneNodeFunc(dom);

    this.$nextTick(async () => {
      let uri = await this.makeSvgDataUri(cc, this.matrix.w, this.matrix.h);
      let imgDom = await this.makeImage(uri);
      imgDom.setAttribute('width', this.matrix.w + 'px');
      imgDom.setAttribute('height', this.matrix.h + 'px');
      let canvas = this.$refs.canvasEl;
      canvas.width = this.matrix.w;
      canvas.height = this.matrix.h;
      let ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(imgDom, 0, 0, canvas.width, canvas.height);
      this.ctx = ctx;
    });
  },
  methods: {
    mousemove(e) {
      let rect = e.target.getBoundingClientRect();
      let x = e.clientX - rect.left;
      let y = e.clientY - rect.top;
      let data = this.getCanvasPixelColor(this.ctx, x, y);
      this.isShowTip = true;

      this.tm.x = x + 50;
      this.tm.y = y - 25;
      this.tm.bg = data;
    },
    mousedown(e) {
      let rect = e.target.getBoundingClientRect();
      let x = e.clientX - rect.left;
      let y = e.clientY - rect.top;
      let data = this.getCanvasPixelColor(this.ctx, x, y);
      this.$bus.emit('eyedropper', { type: 'mousedown', color: data });
    },
    mouseleave() {
      this.isShowTip = false;
    },
    makeImage(uri) {
      return new Promise(function(resolve, reject) {
        var image = new Image();
        image.onload = function() {
          resolve(image);
        };
        image.onerror = reject;
        image.src = uri;
      });
    },
    makeSvgDataUri(node, width, height) {
      return Promise.resolve(node)
        .then(function(node) {
          node.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
          node.style.width = width + 'px';
          node.style.height = height + 'px';
          node.style.top = '0px';
          node.style.left = '0px';
          return new XMLSerializer().serializeToString(node);
        })
        .then(this.escapeXhtml)
        .then(function(xhtml) {
          return '<foreignObject x="0" y="0" width="100%" height="100%" postion="relative">' + xhtml + '</foreignObject>';
        })
        .then(function(foreignObject) {
          return '<svg xmlns="http://www.w3.org/2000/svg" width="' + width + '" height="' + height + '">' + foreignObject + '</svg>';
        })
        .then(function(svg) {
          return 'data:image/svg+xml;charset=utf-8,' + svg;
        });
    },
    escapeXhtml(string) {
      return string.replace(/#/g, '%23').replace(/\n/g, '%0A');
    },
    asArray(arrayLike) {
      let array = [];
      let length = arrayLike.length;
      for (let i = 0; i < length; i++) array.push(arrayLike[i]);
      return array;
    },
    async cloneNodeFunc(node) {
      if (!node) return false;
      if (node.classList && node.classList.contains('color-pick-btn')) return false;
      let clone = await this.makeNodeCopy(node);
      let clones = await this.cloneChildren(node, clone);
      return this.processClone(node, clones);
    },
    async makeNodeCopy(node) {
      if (node instanceof HTMLVideoElement) {
        return await this.videoDomClone(node);
      }
      return node.cloneNode(false);
    },
    async videoDomClone(video) {
      let canvas = document.createElement('canvas');
      canvas.width = video.clientWidth;
      canvas.height = video.clientHeight;
      video.crossorigin = 'anonymous';
      let ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      let img = await this.makeImage(canvas.toDataURL('image/jpeg', 1.0));
      img.style.width = canvas.width;
      img.style.height = canvas.height;
      return img;
    },
    async cloneChildren(original, clone) {
      let children = original.childNodes;
      if (children.length === 0) return clone;

      let arr = this.asArray(children);

      for (let i = 0; i < arr.length; i++) {
        let childClone = await this.cloneNodeFunc(arr[i]);
        if (childClone) clone.appendChild(childClone);
      }

      return clone;
    },
    processClone(original, clone) {
      if (!(clone instanceof Element)) return clone;

      // if(original instanceof HTMLVideoElement) return clone;
      // -------cloneStyle--------
      let source = window.getComputedStyle(original);
      let target = clone.style;

      if (source.cssText) {
        target.cssText = source.cssText;
      } else {
        this.asArray(source).forEach((name) => {
          target.setProperty(name, source.getPropertyValue(name), source.getPropertyPriority(name));
        });
      }

      return clone;
    },
    getCanvasPixelColor(ctx, x, y) {
      // extract the pixel data from the canvas
      let pixel = ctx.getImageData(x, y, 1, 1).data;

      // set each color property
      pixel.r = pixel[0];
      pixel.g = pixel[1];
      pixel.b = pixel[2];
      // pixel.a = pixel[3];

      return '#' + pixel.r.toString(16).padStart(2, 0) + pixel.g.toString(16).padStart(2, 0) + pixel.b.toString(16).padStart(2, 0);
    }
  }
};
</script>
<style lang="scss" scoped>
.eyedropper {
  position: absolute;
  top: 0;
  left: 0;

  canvas {
    cursor: url(/toolkit/img/icon-eyedropper-new.cur), auto;
  }
}
.eyedropper-tip {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  width: 74px;
  height: 74px;
  box-shadow: 0px 0px 0px 4px #bfc7e0;
}
</style>
